import { FinancialAccount } from "../models/FinancialAccount";
import api from "./api";

export const FinancialAccountService = {
  async getFinancialAccounts(): Promise<FinancialAccount[]> {
    const res = await api.get(`/api/v1/financial-accounts`);
    return res.data?.data ?? [];
  },

  async getFinancialAccount(
    financialAccountId: string,
  ): Promise<FinancialAccount> {
    const res = await api.get(
      `/api/v1/financial-accounts/${financialAccountId}`,
    );
    return res.data?.data;
  },

  async updateFinancialAccount(
    financialAccountId: string,
    financialAccountData: Partial<Omit<FinancialAccount, "_id">>,
  ): Promise<void> {
    await api.put(
      `/api/v1/financial-accounts/${financialAccountId}`,
      financialAccountData,
    );
  },

  async deleteFinancialAccount(
    matterId: string,
    financialAccountId: string,
  ): Promise<void> {
    await api.delete(`/api/v1/financial-accounts/${financialAccountId}`, {
      params: { matterId },
    });
  },
};
